<template>
  <div class="page-container mt-4">
    <section id="section__certificate">
      <StaticGuide>
        <template #logo><span></span></template>
        <template #contents>
          <v-row no-gutters class="py-8">
            <v-col cols="12">
              <p class="font--p-3 mt-5 mb-5">
                고객님의 카카오톡으로 인증 요청이 전송되었습니다. <br />카카오톡에서 인증 후, 아래 
                확인 버튼을 눌러주세요
              </p>
            </v-col>
          </v-row>
        </template>

        <template #activator>
          <v-row no-gutters>
            <v-col cols="12">
              <BasicButton @click="confirm" :loading="confirmLoading" :disabled="confirmLoading">
                확인
              </BasicButton>
            </v-col>
          </v-row>
        </template>
      </StaticGuide>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import StaticGuide from '@/components/common/guide/StaticGuide.vue'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  components: {
    StaticGuide,
  },
  data() {
    return {
      file: null,
      confirmLoading: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
  },
  created() {
    _meta({
      titles: ['소득금액증명원확인'],
    })
  },
  methods: {
    ...mapActions('document', ['getIssueIncomeCertification']),
    async confirm() {
      this.confirmLoading = true
      this.file = {
        stepData: this.$route.query.stepdata,
      }
      try {
        await this.getIssueIncomeCertification(this.file)
        const confirm = await this.$swal.basic.alert({
          showCloseButton: false,
          html: '완료되었습니다',
          confirmButtonText: 'OK',
        })
        if (confirm.isConfirmed) {
          if (await redirectSignupManage()) {
            return
          }
          if (this.referralCode || this.registerWooriCrowd) {
            await this.$router.replace({ name: 'signup/limit-transaction' })
          } else {
            await this.$router.replace({ name: 'guide/ready/service' })
          }
        }
      } catch (e) {
        const errorMessage = e.data.errorMessage
        if (e.status === 500) {
          const error = await this.$swal.basic.error({
            html: `소득금액증명원 발급에 실패하였습니다. <br /><p style="font-size:80%; font-weight:bold;">발급 실패가 지속될 경우 02-6925-1788로 문의해주세요</p>`,
            icon: 'warning',
          })
          if (error.isConfirmed) {
            this.$router.replace({ name: 'documents/income-certification' })
          }
        } else {
          const swal = await this.$swal.basic.alert({
            showCloseButton: false,
            html:
              '<strong>소득금액증명원 발급에 실패하였습니다.</strong><br/><p style="font-size:80%; font-weight:bold;">발급 실패가 지속될 경우 02-6925-1788로 문의해주세요</p><br/><p style="padding:20px 5px 20px 5px; border:1px solid; font-size:small;">' +
              errorMessage +
              '</p>' +
              '<br />',
            confirmButtonText: 'OK',
          })
          if (swal.isConfirmed) {
            const signatureError = errorMessage.includes('서명되지 않았습니다.')
            if (!signatureError) {
              this.$router.replace({ name: 'documents/income-certification' })
            }
            return
          }
        }
      } finally {
        this.confirmLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
